// extracted by mini-css-extract-plugin
module.exports = {"r3pisoy":"r3pisoy","s1dkpp8s":"s1dkpp8s"};